import {
  ORGANIZATION_HOST,
  ORGANIZATION_INSTANCE,
  ACCOUNT_HOST,
  ACCOUNTS_INSTANCE,
  EDUCATION_HOST,
  EDUCATION_INSTANCE,
  FEEDBACK_HOST,
  FEEDBACK_INSTANCE,
  MAILCONTROL_HOST,
  MAILCONTROL_INSTANCE,
  SIGNER_HOST,
  SIGNER_INSTANCE,
  REFERENCE_HOST,
  REFERENCE_INSTANCE,
  EVENTCHAIN_HOST,
  EVENTCHAIN_INSTANCE
} from '@/helper/consts'
import { getUrlAllowed, getUrlWithParameters } from '@/helper/urls'

export default {
  getAccountsUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API аккаунтов
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      ACCOUNT_HOST, ACCOUNTS_INSTANCE, name, method, parameters, gets
    )
  },
  getWorkerUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API работников
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      ORGANIZATION_HOST, ORGANIZATION_INSTANCE, name, method, parameters, gets
    )
  },
  allowedWorkerOrderUrl (name, method) {
    /**
     * Проверяет разрешение доступа к эндпоинту работников
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @returns {boolean} true, если URL допустим, иначе false
     */
    return getUrlAllowed(ORGANIZATION_INSTANCE, name, method)
  },
  getEducationUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API образования
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      EDUCATION_HOST, EDUCATION_INSTANCE, name, method, parameters, gets
    )
  },
  allowedEducationOrderUrl (name, method) {
    /**
     * Проверяет разрешение доступа к эндпоинту образования
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @returns {boolean} true, если URL допустим, иначе false
     */
    return getUrlAllowed(EDUCATION_HOST, name, method)
  },
  getFeedbackUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API обратной связи
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      FEEDBACK_HOST, FEEDBACK_INSTANCE, name, method, parameters, gets
    )
  },
  getMailUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API почты
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      MAILCONTROL_HOST, MAILCONTROL_INSTANCE, name, method, parameters, gets
    )
  },
  getSignerUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API системы электронной подписи
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      SIGNER_HOST, SIGNER_INSTANCE, name, method, parameters, gets
    )
  },
  getEventChainUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API цепочки событий
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      EVENTCHAIN_HOST, EVENTCHAIN_INSTANCE, name, method, parameters, gets
    )
  },
  getReferenceUrlWithParameters: function (name, method, parameters, gets) {
    /**
     * Получает URL для API справочника
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @param {Object} parameters - параметры для подстановки
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    return getUrlWithParameters(
      REFERENCE_HOST, REFERENCE_INSTANCE, name, method, parameters, gets
    )
  },
  getReferenceUrlAllowed: function (name, method) {
    /**
     * Проверяет разрешение доступа к эндпоинту справочника
     * @param {string} name - шаблон пути
     * @param {string} method - HTTP метод
     * @returns {boolean} true, если URL допустим, иначе false
     */
    return getUrlAllowed(REFERENCE_INSTANCE, name, method)
  }
}
